import React from 'react';
import './scss/collection-view.scss';
import CollectionProp from './properties/collection';
import EmptyView from './empty-view';
import FormDialog from './form-dialog';
import ContractModel from '../models/contract';
import AssetKeyForm from './asset-key-form';
import TokenUrlForm from './token-url-form';

function CollectionView({
                            collection,
                            contracts,
                            setStatusMessage,
                        }: CollectionProp): React.ReactElement {
    const contractToEditInit: ContractModel = {
        collections: [],
        token: {
            tokenId: '',
            tokenUrl: '',
        },
        blockchain: '',
        standard: '',
        address: '',
        assetKeyId: '',
        baseTokenUrl: '',
        metadataType: ''
    };
    const contractHref = `/contract?action=add&collectionId=${collection?.collectionId}`;
    const [updateModalShow, setUpdateModalShow] = React.useState(false);
    const [contractToEdit, setContractToEdit] = React.useState(contractToEditInit);
    const [editField, setEditField] = React.useState('');

    const handleFormSubmit = (event: any) => {
        event.preventDefault();
    };

    return (
        collection ? (
            <div className="collection-view">
                <FormDialog
                    show={updateModalShow}
                    onHide={(reload, reason) => {
                        if (reason) setUpdateModalShow(false);
                        if (reload) {
                            window.location.reload();
                        }
                    }}
                    setStatusMessage={setStatusMessage}
                    onSubmit={handleFormSubmit}
                    formElement={editField === 'assetKeyId'
                        ? (
                            <AssetKeyForm
                                collectionId={collection?.collectionId}
                                contract={contractToEdit}
                                setStatusMessage={setStatusMessage}
                                handleClose={() => {
                                    setUpdateModalShow(false);
                                }}
                            />
                        )
                        : (
                            <TokenUrlForm
                                collectionId={collection?.collectionId}
                                contract={contractToEdit}
                                setStatusMessage={setStatusMessage}
                                handleClose={() => {
                                    setUpdateModalShow(false);
                                }}
                            />
                        )}
                />
                <div className="rounded ">
                    <div className="text-center">
                        <img src={collection?.imageUrl} className="rounded-circle" alt={collection?.name}/>
                        <div className="content-fluid">
                            <h5 className="pt-4">{collection?.name}</h5>
                            <p className="pt-3">
                                {collection?.description}
                            </p>
                            <hr className=""/>
                        </div>
                    </div>
                </div>
                <div className="content-fluid pb-5">
                    <div className="table-heading">
                        <h5 className="pb-2">Contracts</h5>
                        <a
                            href={contractHref}
                            type="button"
                            data-bs-toggle="tooltip"
                            data-bs-placement="top"
                            title="Add new contract"
                            className="btn btn-light float-end"
                        >
                            Add New
                        </a>
                    </div>
                    <table className="table  table-striped">
                        <thead>
                        <tr>
                            <th>Address</th>
                            <th>Chain</th>
                            <th>Standard</th>
                            <th>Asset Key Id</th>
                            <th>Base Token Url</th>
                        </tr>
                        </thead>
                        {(!contracts || (contracts && contracts?.length) === 0) ? (
                                <tbody>
                                <tr>
                                    <td colSpan={5}><EmptyView title="No contracts found in collection" desc=""/></td>
                                </tr>
                                </tbody>
                            )
                            : (
                                <tbody>
                                {contracts?.map((contract, index) => (
                                    <tr key={index}>
                                        <td>
                                            <a href={`/contract?hash=${contract.address}`}>
                                                {contract.address}
                                            </a>
                                        </td>
                                        <td>
                                            {contract.blockchain}
                                        </td>
                                        <td>{contract.standard}</td>
                                        <td>
                                            <span className="me-2">{contract.assetKeyId}</span>
                                            <span>
                          <a
                              className="text-decoration-underline"
                              style={{fontSize: '14px'}}
                              href="#asset-key-edit"
                              onClick={(() => {
                                  setEditField('assetKeyId');
                                  setContractToEdit(contract);
                                  setUpdateModalShow(true);
                              })}
                          >
                            {contract.assetKeyId || contract.assetKeyId?.length > 0 ? 'Edit' : 'Add'}
                          </a>
                        </span>
                                        </td>
                                        <td style={{
                                            width: '30%',
                                            textDecoration: 'underline',
                                        }}
                                        >
                                            <span className="me-2 text-break">{contract?.baseTokenUrl}</span>
                                            <span>
                          <a
                              className="text-decoration-underline"
                              style={{fontSize: '14px'}}
                              href="#token-url"
                              onClick={(() => {
                                  setEditField('baseTokenUrl');
                                  setUpdateModalShow(true);
                                  setContractToEdit(contract);
                              })}
                          >
                            {contract?.baseTokenUrl || contract?.baseTokenUrl?.length > 0 ? 'Edit' : 'Add'}
                          </a>
                        </span>
                                        </td>
                                    </tr>
                                ))}
                                </tbody>
                            )}
                    </table>
                </div>
            </div>
        ) : <EmptyView title="Collection not found" desc=""/>
    );
}

export default CollectionView;
